import React from "react";

interface ArrowTopGIconProps {
  width?: number | string;
  height?: number | string;
  fillColor?: string;
  className?: string;
}

const ArrowTopGIcon: React.FC<ArrowTopGIconProps> = ({
  width = 16,
  height = 16,
  fillColor = "#00FC8C",
  className = "",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill={fillColor}
      className={className}
    >
      <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0" />
    </svg>
  );
};

export default ArrowTopGIcon;
